var CombinedExpandState = /** @class */ (function () {
    function CombinedExpandState(customerId, nextRequestId, facets, pageId, onlyInStock, nextPage, searchTerm, filterItems) {
        this.customerId = customerId;
        this.nextRequestId = nextRequestId;
        this.facets = facets;
        this.pageId = pageId;
        this.onlyInStock = onlyInStock;
        this.nextPage = nextPage;
        this.searchTerm = searchTerm;
        this.filterItems = filterItems;
    }
    Object.defineProperty(CombinedExpandState.prototype, "valueKey", {
        get: function () {
            var _this = this;
            return this.pageId + " - " + this.nextRequestId + " - " + this.onlyInStock + " - " + Object.keys(this.facets).reduce(function (prev, curr) { return curr + "=(" + _this.facets[curr].join('|') + ")"; }, '');
        },
        enumerable: true,
        configurable: true
    });
    return CombinedExpandState;
}());
export { CombinedExpandState };
